module.exports = __webpack_public_path__ + "static/room3-2-cee0ba08f3df7a8e52bd615670e58f94.jpg";